module.exports = __webpack_public_path__ + "components/weather-icon/static/daymodrain@2-2e7cdd44a80cf53987c63d9309991de1.png";